<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="myRules", :class="formItemClass")
  Uploader(ref="uploader", @file-error="onUploadError", type-key="3", @fileAdded="fileAdded", :before-upload="beforeUpload")
  .tools-top
    el-button(v-if="showTemBtn", type="text", icon="el-icon-download", @click="openTemDialog", title="下载模版")
    el-button(v-if="isEdit", type="text", icon="el-icon-plus", @click="h5OpenUploadSheet")
  FileTable(
    :class="{ useTarget: requiredTarget }",
    ref="fileTable",
    :show-selection.sync="h5.selection",
    :file-list="fieldModel || []",
    :preview="preview",
    :delete="isEdit",
    @delete="onFileRemove",
    :download="downloadHandler",
    :h5FileSheet="getH5FileSheet",
    @updateLight="updateLight"
  )
  .sticky-tools(v-if="h5.selection && fieldModel.length")
    .tools-item.err(v-if="isEdit", @click="deleteBatch") 删除
    .tools-item(v-if="isEdit && useTarget", @click="setTargetFolder(checkedFile)") 设置目录
    .tools-item(v-if="isEdit && dictType", @click="batchGroup(checkedFile)") 选择分组
    .tools-item(@click="toggleAll") 全选/全不选
    .tools-item(@click="cancelH5Selection") 退出
  van-popup(v-model="h5.showPrototype", position="bottom")
    .template-title 文件属性
    template(v-if="h5CurrentFile")
      .file-basic
        FileIcon.file-basic-icon(:row="h5CurrentFile", :icon-size="24", readonly)
        FileName.file-basic-name(:name="h5CurrentFile.fileName")
      van-cell-group
        van-cell(v-if="useTarget", title="设置目录", is-link, :value="h5CurrentFile.targetFolderPath || '未配置'", @click="h5prototypeClick(setTargetFolder)")
        van-cell(v-if="dictType", title="分组", is-link, :value="h5CurrentFile.groupName", @click="h5prototypeClick(batchGroup)")
        van-cell(title="大小", :value="h5CurrentFile.fileSize | fileSize")
        van-cell(title="文件路径", :value="h5CurrentFile.filePath")
        van-cell(title="创建人", :value="h5CurrentFile.checkInUser")
        van-cell(title="创建时间", :value="h5CurrentFile.checkInDate")
  van-popup(v-model="template.visible", position="bottom")
    .template-title 下载模版
    file-list(:file-list="templateList", :hover="false", @download="downloadHandler")
  van-action-sheet(v-model="h5.showUploadSheet", cancel-text="取消", close-on-click-action, :actions="h5UploadSheet", @select="handleCommand($event.id)")
</template>
<script>
import { fileSize } from "@/CommonDP/components/FileList/file.js";
import FileIcon from "@/CommonDP/components/FileList/FileIcon.vue";
import FileName from "@/CommonDP/components/FileList/fileName.vue";
import PC_UPLOAD from "../index.vue";
import FileTable from "./list.vue";
import { openDoc } from "./utils.js";
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";
export default {
  filters: { fileSize },
  components: { FileTable, FileIcon, FileName },
  extends: PC_UPLOAD,
  data() {
    return {
      h5: { showUploadSheet: false, selection: false, uploadSheet: [], showPrototype: false, curFile: null }
    };
  },
  computed: {
    h5CurrentFile() {
      return this.h5.curFile;
    },
    isEdit() {
      return true;
    },
    h5UploadSheet() {
      return this.tools.map(({ id, cnName }) => ({ id: id, name: cnName }));
    }
  },
  methods: {
    openDoc,
    preview(file) {
      const flowInstanceId = this.getFlowDetail?.()?.detail?.flowInstanceId;
      viewAppFileMethods(file, {
        flowInstanceId,
        fileType: file.fileType,
        fileId: file.fileId,
        versionId: file.fileVersion || file.version || 1
      });
    },
    async h5prototypeClick(fn) {
      this.h5.showPrototype = false;
      await fn?.(this.h5CurrentFile);
      this.h5.showPrototype = true;
    },
    toggleAll() {
      const {
        fieldModel,
        $refs: {
          fileTable: {
            checkedIds,
            $refs: { container }
          }
        }
      } = this;
      container.toggleAll(checkedIds.length !== fieldModel.length);
    },
    cancelH5Selection() {
      this.h5.selection = false;
    },
    h5OpenUploadSheet() {
      this.h5.showUploadSheet = true;
    },
    // 打开文件属性面板
    h5OpenPrototypePanel(file) {
      this.h5.curFile = file;
      this.h5.showPrototype = true;
    },
    // 单击文件打开的功能
    getH5FileSheet(row, sheets = []) {
      const { fieldModel: list = [], isEdit, dictType, useTarget } = this;
      const file = list.find(({ fileId }) => fileId === row.fileId);
      if (!file) return sheets;
      isEdit && dictType && sheets.push({ name: "设置分组", handler: () => this.batchGroup(file) });
      isEdit && useTarget && sheets.push({ name: "设置存放位置", handler: () => this.setTargetFolder(file) });
      sheets.push({ name: "属性", handler: () => this.h5OpenPrototypePanel(file) });
      return sheets;
    },
    toggleSelection() {
      this.h5.selection = !this.h5.selection;
    }
  }
};
</script>
<style lang="scss" scoped src="./h5.scss"></style>
